<template>
    <div>
        <CustomFiltersItems
:order-options="orderOptions" :items-per-page="itemsPerPage" :show-deleted="showDeleted"
            @apply-filter="applyFilter" @update-items-per-page="updateItemsPerPage"
            @update-show-deleted="updateShowDeleted" />

        <div class="card-container">
            <div v-for="item in filteredItems.data" :key="item.id" class="card" @click="selectItem(item)">
                <div v-if="item.discount > 0.00" class="card-header">
                    <span v-if="item.discount" class="discount-badge">Descuento<br>de $ {{ item.discount }}</span>
                </div>
                <img :src="item.image || photoDefault" alt="Imagen del producto/servicio" class="card-img">
                <div class="card-body">
                    <h5 class="card-title">{{ item.name }}</h5>
                    <p class="card-text">{{ item.description }}</p>
                    <div class="price-container">
                        <span class="current-price">${{ item.price }}</span>
                        <span v-if="item.originalPrice" class="original-price">${{ item.originalPrice }}</span>
                    </div>
                </div>
            </div>
        </div>

        <Pagination
class="mt-3" :total-items="totalItems" :current-page="currentPage" :last-page="lastPage"
            :items-per-page="itemsPerPage" @page-change="changePage" />

        <Modal v-if="openModal" v-model="openModal" :is-edit-mode="isEditMode" @submit-entity="handleEntity">
            <template #default>
                <div class="row mb-3">
                    <div v-if="entity.stock" class="col-md-2">
                        <label for="discount" class="form-label">Stock</label>
                        <input id="discount" v-model="entity.stock" type="text" class="form-control" disabled>
                    </div>
                    <div class="col-md-3">
                        <label for="quantity" class="form-label">Cantidad</label>
                        <Quantity v-model="entity.quantity" />
                    </div>
                    <div class="col-md-2">
                        <label for="discount" class="form-label">Descuento</label>
                        <input id="discount" v-model="entity.discount" type="text" class="form-control" disabled>
                    </div>
                    <div class="col-md-2">
                        <label for="discount" class="form-label">IVA (%)</label>
                        <input id="discount" v-model="entity.tax" type="text" class="form-control" disabled>
                    </div>
                    <div class="col-md-3">
                        <label for="price" class="form-label">Precio</label>
                        <input id="price" v-model="entity.price" type="text" class="form-control" disabled>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="description" class="form-label">Descripción</label>
                    <input id="description" v-model="entity.description" type="text" class="form-control">
                </div>
                <div class="mb-3">
                    <label for="comments" class="form-label">Comentarios</label>
                    <input id="comments" v-model="entity.comments" type="text" class="form-control">
                </div>
            </template>
        </Modal>
    </div>
</template>

<script setup>
import { ref, defineEmits, watch, onMounted } from 'vue';
import Pagination from '@/components/Pagination.vue';
import CustomFiltersItems from './CustomFiltersItems.vue';
import { useActions } from '@/composables/useActions';
import Modal from '@/components/Modal.vue';
import Quantity from '@/components/Quantity.vue';
import photoDefault from "@/assets/img/product_icon.png";

const resourceApi = 'items';
const openModal = ref(false);
const isEditMode = ref(false);

const emit = defineEmits(['get-entity']);

const orderOptions = [
    { text: 'Lo más vendido', value: 'bestseller' },
    { text: 'Ofertas', value: 'offers' },
    { text: 'Fecha de modificación', value: 'updated_at' },
    { text: 'Fecha de creación', value: 'created_at' },
    { text: 'Productos', value: 'product' },
    { text: 'Servicios', value: 'service' },
    { text: 'Nombre', value: 'name' }
];

const showDeleted = ref(false);

const {
    currentPage,
    itemsPerPage,
    lastPage,
    filteredItems,
    totalItems,
    changePage,
    fetchItems,
    applyFilter,
    updateItemsPerPage,
    updateShowDeleted,
    showRecord
} = useActions(resourceApi);

watch([itemsPerPage, currentPage], ([newItemsPerPage, newPage]) => {
    if (newItemsPerPage || newPage) {
        fetchItems(newPage);
    }
});

const entity = ref({});

const selectItem = async (item) => {
    entity.value = await showRecord(item, resourceApi);
    entity.value.quantity = 1;
    entity.value.comments = item.comments;
    openModal.value = true;
};

const handleEntity = async () => {
    emit('get-entity', entity.value);
    openModal.value = false;
};

onMounted(async () => {
    await fetchItems();
});
</script>

<style scoped>
.card-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    /* Mostrar tres elementos por fila */
    gap: 1.5rem;
    justify-content: center;
    cursor: pointer;
}

.card {
    border: none;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    background: #fff;
    position: relative;
}

.card:hover {
    transform: translateY(-10px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.card-header {
    position: absolute;
    top: 12px;
    left: 0;
    background: #2c3e50;
    color: white;
    padding: 10px 20px;
    font-size: 1rem;
    font-weight: bold;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    clip-path: polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%);
    text-align: center;
}

.discount-badge {
    display: block;
    text-align: center;
    font-size: 0.9rem;
    line-height: 1.2;
    font-weight: bold;
    color: white;
}

.card-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-bottom: 1px solid #ddd;
    border-radius: 12px;
    /* Bordes redondeados */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* Sombra suave */
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    /* Animación */
}

.card-img:hover {
    transform: scale(1.05);
    /* Efecto de zoom al pasar el mouse */
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
    /* Aumenta la sombra en hover */
}

.card-body {
    padding: 1.5rem;
    text-align: center;
}

.card-title {
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: #333;
}

.card-text {
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 1rem;
}

.price-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
}

.current-price {
    font-size: 1.4rem;
    font-weight: bold;
    color: #28a745;
}

.original-price {
    font-size: 1rem;
    color: #999;
    text-decoration: line-through;
}

.card-img,
.card-img-bottom {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
</style>
